import { useEffect, useState } from 'preact/hooks'

/** Banners asking to set up this device, first shown first: only one at a time. */
const PRIORITY = ['passkey', 'install', 'push'] as const
export type PromptId = (typeof PRIORITY)[number]

const wanting = new Set<PromptId>()
const subscribers = new Set<() => void>()
const notify = () => {
  for (const subscriber of subscribers) subscriber()
}

/** Registers `id` as wanting to show; returns its release. */
export function wantPrompt(id: PromptId): () => void {
  wanting.add(id)
  notify()
  return () => {
    wanting.delete(id)
    notify()
  }
}

export function currentPrompt(): PromptId | undefined {
  return PRIORITY.find((id) => wanting.has(id))
}

/** Whether the banner `id`, when it `wants` to show, is the one to show now. */
export function usePromptTurn(id: PromptId, wants: boolean): boolean {
  const [, setVersion] = useState(0)
  useEffect(() => {
    const update = () => setVersion((version) => version + 1)
    subscribers.add(update)
    return () => {
      subscribers.delete(update)
    }
  }, [])
  useEffect(() => (wants ? wantPrompt(id) : undefined), [id, wants])
  return wants && currentPrompt() === id
}
